import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ScheduleSmsEdition as ScheduleSmsEditionMutation,
    ScheduleSmsEditionVariables as ScheduleSmsEditionVariables,
    EditionScheduleInput,
} from 'nutshell-graphql-types';

import SCHEDULE_SMS_EDITION from '../mutations/schedule-sms-edition.graphql';

export const useScheduleSmsEdition = (): {
    scheduleSmsEdition: (arg1: EditionScheduleInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [scheduleSmsEdition, {loading, error}] = useMutation<
        ScheduleSmsEditionMutation,
        ScheduleSmsEditionVariables
    >(SCHEDULE_SMS_EDITION);

    return {
        scheduleSmsEdition: (input: EditionScheduleInput) =>
            scheduleSmsEdition({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
